import styled from 'styled-components/macro';

export default styled('h2')`
  font-size: ${(props) => props.theme.fontSize[`h${props.size || 3}`]}px;
  font-weight: bold;
  color: ${(props) => (props.color ? props.theme.textColors[props.color] : props.theme.textColors.default)};
`;
